export const thumbOverBelt = (ctx: CanvasRenderingContext2D, beltColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = beltColor

  // ベルト上
  ctx.beginPath()
  ctx.moveTo(268, 534) // 左上
  ctx.quadraticCurveTo(288, 599, 263, 625) //左下
  ctx.quadraticCurveTo(381, 668, 444, 615) //右下
  ctx.quadraticCurveTo(468, 501, 468, 501) //右上
  ctx.quadraticCurveTo(449, 552, 268, 534) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // ベルト左
  ctx.beginPath()
  ctx.lineWidth = 1.4
  ctx.fillStyle = '#fff'
  ctx.moveTo(301, 564)
  ctx.arc(301, 564, 4, 0, 2 * Math.PI)
  ctx.moveTo(297, 610)
  ctx.arc(297, 610, 4, 0, 2 * Math.PI)
  ctx.stroke()
  ctx.fill()
  ctx.closePath()
}
